// src/app/core/services/delegation-token.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Etat de delegation partage avec DelegationInterceptor.
 * Le backend n'emet pas de jeton de delegation : la delegation active est transmise
 * dans l'en-tete X-Delegation (id de la delegation), lu par JwtAuthenticationFilter.
 */
@Injectable({
  providedIn: 'root'
})
export class DelegationTokenService {

  private readonly isDelegating$ = new BehaviorSubject<boolean>(false);
  private delegationId: string | null = null;

  constructor() {
    this.initializeFromStorage();
  }

  private initializeFromStorage() {
    const delegationStateStr = localStorage.getItem('delegationState');

    if (delegationStateStr) {
      try {
        const delegationState = JSON.parse(delegationStateStr);
        const now = new Date();
        const expiresAt = new Date(delegationState.expiresAt);

        if (expiresAt > now && delegationState.delegationId) {
          this.delegationId = String(delegationState.delegationId);
          this.isDelegating$.next(true);
        } else {
          this.clearDelegation();
        }
      } catch (error) {
        console.error('Error parsing delegation state:', error);
        this.clearDelegation();
      }
    }
  }

  setDelegationId(delegationId: string) {
    this.delegationId = delegationId;
    this.isDelegating$.next(true);
  }

  getDelegationId(): string | null {
    return this.delegationId;
  }

  isDelegating(): Observable<boolean> {
    return this.isDelegating$.asObservable();
  }

  isDelegatingSync(): boolean {
    return this.isDelegating$.getValue();
  }

  clearDelegation() {
    this.delegationId = null;
    this.isDelegating$.next(false);
  }
}
